import { render, staticRenderFns } from "./RecomendationItem.vue?vue&type=template&id=53f72a6e&scoped=true"
import script from "./RecomendationItem.vue?vue&type=script&lang=js"
export * from "./RecomendationItem.vue?vue&type=script&lang=js"
import style0 from "./RecomendationItem.vue?vue&type=style&index=0&id=53f72a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f72a6e",
  null
  
)

export default component.exports